import { Observable, of as observableOf } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { AppStore } from '../stores/app.store';

@Injectable()
export class AdvertisementsService {

  private cached;

  constructor(
    private httpClient: HttpClient,
    private store: AppStore) {

    this.load();
  }

  load(force = false) {

    if (!environment.api.ads.enabled) {
      return observableOf(null);
    }

    if (this.cached && !force) {
      return observableOf(this.cached);
    }

    const base = `${environment.api.base}`;
    const path = `${environment.api.ads.path}`;
    const token = `${this.store.companyToken}` || `${environment.api.ads.token}`;
    const url = `${base}${path}?event_id=${this.store.eventId}&token=${token}`;

    return this.httpClient.get<any>(url).pipe(
      map(data => {
        this.cached = data;
        return data;
      })
    );
  }

  advertisements() {
    return this.load().pipe(
      map(data => {
        const advertisements = [];

        if (<any>data && (<any>data).advertisements) {
          (<any>data).advertisements.forEach(ad => {
            if (ad.type && ad.type === 1) {
              advertisements.push(ad.banner);
            }
          });
        }
        return advertisements;
      })
    );
  }
}
